import GovernmentInsuranceNotice from './GovernmentInsuranceNoticeContainer';

export default GovernmentInsuranceNotice;
